import React from 'react';

import { cf } from './c_20210427a_YSh/cf';
import { ce } from './c_20210427a_YSh/ce';
import { iv } from './c_20210427a_YSh/iv';
import { ic } from './c_20210427a_YSh/ic';
import { bf } from './c_20210427a_YSh/bf';
import { cp } from './c_20210427a_YSh/cp';
import { ip } from './c_20210427a_YSh/ip';

import cView from './c_20210427a_YSh/cView';

export default class iMngDtl extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  };

  $id_stss = {
    s_cm40c310: '',
    sdd_it10ss: {},
    sld_chkIss: [],
    sld_caseIss: [],
    sld_ct30Iss: [], // 権限設定情報
    sld_cm30ss: [],
  };

  $ilp_bfrLoads = () => [

    cp.$cp_hlr_cm31({
      mode: 'set',
      cnd: bf.q('[cm31b21k]="{}" AND [cm31b31k]="{}"'.f(
        global.c?.state.sgcd_pagePntKeys.cm30_key,
        global.c?.state.sgcd_pagePntKeys.cm10_key,
      )),
    }),

    cp.$cp_hlr_cm30({ // 分類情報
      mode: 'set',
      cnd: bf.q('[_KEY]={}'.f(
        global.c?.state.sgcd_pagePntKeys.cm30_key,
      )),
    }),
  ];

  $ilp_loads = () => [


    cp.$cp_hlr_cm40({ // 分類情報
      mode: 'set',
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
//      cm40_key: global.c?.state.sgc_pageKey,
      cnd: bf.q('[_KEY]={}'.f(
        global.c?.state.sgc_pageKey,
      )),
    }),

    global.c?._op_load1(),

    global.c?._op_load21(),
    global.c?._op_load22(),

  ];

_op_load1 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_chkIss',
  dd_elmDefss: {
    cm40: { // alias
      elm: 'cm40',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [cm40b11k]="{}" AND 
          [cm40l11e]="mngCtg" AND 
          [cm40l11k]="{}" AND 
          IFNULL([cm40cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
        ));
        return _cnd;
      },
      ld_sortss: [
        { fld: 'cm40cx10', dtn: 'asc', mode: 'nmb' },
        { fld: 'cm40cw10', dtn: 'asc', mode: 'str' },
        { fld: '_KEY', dtn: 'asc', mode: 'nmb' },
      ],
      dd_cldDefss: {
        it10: { // alias
          elm: 'it10',
          n_dms: 3,
          o_cnd: _dd_prtss => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND 
              [it10l11e]="mngChk" AND 
              [it10l11k]="{}" AND 
              IFNULL([it10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_prtss.cm40.d_flds._KEY,
            ));
            return _cnd;
          },
          ld_sortss: [
            { fld: 'it10cx10', dtn: 'asc', mode: 'nmb' },
            { fld: 'it10cw10', dtn: 'asc', mode: 'str' },
            { fld: '_KEY', dtn: 'asc', mode: 'nmb' },
          ],
          dd_cldDefss: {
          },
        },
      },
    },
  },
});

_op_load21 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_caseIss1', // 共通
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [it10b11k]="{}" AND 
          [it10l11e]="mngCase" AND 
          [it10l11k]="{}" AND 
          [it10t110]="20" AND 
          IFNULL([it10cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
        ));
        return _cnd;
      },
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => (bf.f(_d_flds.it10b21k)) ? bf.q('[_KEY]={}'.f(_d_flds.it10b21k)) : null,
        },
      },
      dd_cldDefss: {
      },
    },
  },
});

_op_load22 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_caseIss2', // 個人
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [it10b11k]="{}" AND 
          [it10l11e]="mngCase" AND 
          [it10l11k]="{}" AND 
          [it10t110]="10" AND 
          IFNULL([it10cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgc_pageKey,
        ));
        return _cnd;
      },
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => (bf.f(_d_flds.it10b21k)) ? bf.q('[_KEY]={}'.f(_d_flds.it10b21k)) : null,
        },
      },
      dd_cldDefss: {
      },
    },
  },
});

_dd_elmDefs2 = {
  it10: { // alias
    elm: 'it10',
    o_cnd: _dd_prtss => {
      let _cnd = bf.q(`
        [it10b11k]="{}" AND 
        [it10l11e]="mngCase" AND 
        [it10l11k]="{}" AND 
        IFNULL([it10cz10],"10")<>"0"
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgc_pageKey,
      ));
      return _cnd;
    },
    dd_cldDefss: {
    },
  },
};

  $ip_ins = () => cp.$cp_hlr_cm40({
    mode: 'ins',
    cm40b11k: bf.b([
      {
        b_when: global.c?.state.sgc_pageRole == 'own1',
        o_then: () => '0',
      },
      {
        o_else: () => global.c?.state.sgcd_pagePntKeys.cm20_key,
      },
    ]),
    cm40b21k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
    cm40l11e: 'mngSht',
    cm40l11k: '2',
    cm40h11k: '1',
    cm40h11c: '2',
    cm40t110: ip.$o_pmn({
      mode: 'type',
    }),
    cm40c110: '',
  });

  $ilp_upds = () => [

    cp.$cp_hlr_cm40({
      mode: 'upd',
      cm40_key: global.c?.state.sgc_pageKey,
    }), // cm40中分類

    cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_chkIss',
      dd_elmDefss: {
        cm40: {
          od_insDats: (pd, _idx) => {
            let _d = {
              cm40b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm40b21k: global.c?.state.sgcd_pagePntKeys.cm30_key, // 追加
              cm40l11e: 'mngCtg',
              cm40l11k: global.c?.state.sgc_pageKey,
              cm40h11c: '3',
              cm40c110: '',
              cm40c310: pd.cm40.d_flds.cm40c310,
              cm40cz10: '10',
              cm40t110: ip.$o_pmn({ // 追加
                mode: 'type',
              }),
              cm40cw10: pd.cm40.d_flds.cm40cw10 ?? bf.myCM_gnr(10),
//              cm40cx10: pd.cm40.d_flds.cm40cw10 || '9999',
//              cm40cx10: pd.cm40.idx ?? '9999',
              cm40cx10: _idx ?? '9999',
            };
//bf.l('254: {}'.f(_d));
//bf.l('255: {}'.f(pd.cm40));
            return _d;
          },
          dd_cldDefss: {
            it10: {
              od_insDats: (pd, _idx) => {
                let _d = {
                  it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0', // 追加
                  it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0', // 追加
                  it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0', // 追加
                  it10l11e: 'mngChk',
                  it10l11k: pd.cm40.d_flds._KEY,
                  it10c110: '',
                  it10c310: pd.it10.d_flds.it10c310,
                  it10cz10: '10', // 表示 
                  it10t110: ip.$o_pmn({ // 追加
                    mode: 'type',
                  }),
                  it10cy10: bf.myDT_get_now(), // 追加
                  it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '', // 追加
//                  it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
//                  it10cx10: pd.it10.d_flds.it10cx10 || '9999',
                  it10cw10: pd.it10.d_flds.it10cw10 ?? bf.myCM_gnr(10),
//                  it10cx10: pd.it10.idx ?? '9999',
                  it10cx10: _idx ?? '9999',
                };
//bf.l('269: {}'.f(_d));
                return _d;
              },
            },
          },
        },
      },
    }),

    cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_caseIss1', // 共通
      dd_elmDefss: {
        it10: {
          od_insDats: pd => {
            let _d = {
              it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0', // 追加
              it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0', // 追加
              it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0', // 追加
              it10l11e: 'mngCase',
              it10l11k: global.c?.state.sgc_pageKey,
              it10c110: '',
              it10c310: pd.it10.d_flds.it10c310,
              it10cz10: '10', // 表示 
              it10t110: ip.$o_pmn({ // 追加
                mode: 'type',
              }),
//              it10cw10: pd.it10.d_flds.it10c310 || bf.myCM_gnr(10),
              it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
              it10cy10: bf.myDT_get_now(), // 追加
              it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '', // 追加
            };
            return _d;
          },
        },
      },
    }),

    cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_caseIss2', // 個人
      dd_elmDefss: {
        it10: {
          od_insDats: pd => {
            let _d = {
              it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0', // 追加
              it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0', // 追加
              it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0', // 追加
              it10l11e: 'mngCase',
              it10l11k: global.c?.state.sgc_pageKey,
              it10c110: '',
              it10c310: pd.it10.d_flds.it10c310,
              it10cz10: '10', // 表示 
              it10t110: ip.$o_pmn({ // 追加
                mode: 'type',
              }),
              it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
              it10cy10: bf.myDT_get_now(), // 追加
              it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '', // 追加
            };
            return _d;
          },
        },
      },
    }),

  ];

  $cld_onChgss = cp.cld_onChgss;

  $pld_onChgss = () => [
  ];

  render() {
//          rhtPfx={null}
    let _sfxH = (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? (ic.gn_fontSizeSml + ic.gn_mgnSml * 2) * 2 : 0;
    let _sfxH1 = (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? (ic.gn_fontSizeSml + ic.gn_mgnSml * 2) * 1 : 0;

    return (
      <this.$onChg>
        <ce.RootDtl
          key={-1}
          b_logo={false}
          b_rhtVsb={(global.c?.state.s_cm31cz10 == '0') ? false : true}
          rhtPfx={
            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) ?
              '反映'
            :
              '登録・変更'
          }
          rhtIconName={null} 
          onRhtPrs={null}
          d_hdrs={{
            pfx:  iv._get_hdrPfx('チェックシート設定情報'),
            d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
            d_subMenus: {
              b_vsb: false,
            },
          }}
          d_bdys={{
            ld_defss: [
              {
                type: 'Inp',
                b_vsb: true,
                b_edt: false,
                state:'s_cm30c310',
                pfx:'部門',
                b_mln:false,
              },

              {
                type:'Inp',
                b_vsb:true,
                b_edt: bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']),
                state:'s_cm40c310',
                pfx:'シート名',
                phd: '新しい項目を追加', 
                b_mln:false,
              },

              {
                type: 'InpTree3',
                b_vsb: true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                state: 'sdld_chkIss',
                dd_elmDefss: {
                  cm40: {
                    pfx: 'チェック項目',
                    d_insDats: {
                      d_flds: {
                        cm40c310: '',
                      },
                    },
                    dd_fldDefss: {
                      cm40c310: {
                        type: 'Inp',
                        phd: 'チェック項目分類を入力ください',
                        b_btnPrs: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                        o_sfx: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return (_d_dats.d_flds.cm40cw10) ? 'ID:{}'.f(_d_dats.d_flds.cm40cw10 ?? '-'): '';
                            }
                          : null
                        ,
                        o_stlCta: _d_is => {
                          let _d = {};
                          _d = {
                            marginBottom: _sfxH1,
                          };
                          return _d;
                        },
/*
                        stlSfx: {
                          bottom: - _sfxH1,
                        },
*/
                        stlSfx: {
                          top: null,
                          left: null,
                          bottom: - _sfxH1,
                          right: ic.gn_mgnNrm,
                        },
                      },
                    },
                    dd_cldDefss: {
                      it10: {
                        d_insDats: {
                          d_flds: {
                            it10c310: '',
                          },
                        },
                        dd_fldDefss: {
                          it10c310: {
                            type: 'Inp',
                            phd: 'チェック項目を入力ください',
                            o_sfx: 
                              (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                                _d_dats => {
                                  return (_d_dats.d_flds.it10cw10) ? 'ID:{}'.f(_d_dats.d_flds.it10cw10 ?? '-'): '';
                                }
                              : null
                            ,
                            o_stlCta: _d_is => {
                              let _d = {};
                              _d = {
                                marginBottom: _sfxH1,
                              };
                              return _d;
                            },
/*
                            stlSfx: {
                              bottom: - _sfxH1,
                            },
*/
                            stlSfx: {
                              top: null,
                              left: null,
                              bottom: - _sfxH1,
                              right: ic.gn_mgnNrm,
                            },
                          },
                        },
                        dd_cldDefss: {
                        },
                      },

                    },
                  },
                },
              },

              {
                type: 'InpTree3',
//                b_vsb: true,
                b_vsb: 
                  (
                    global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                    bf.i(global.c?.state.sgc_pageMode, ['edit'])
                  ) ? 
                    false 
                  : true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                state: 'sdld_caseIss1',
                dd_elmDefss: {
                  it10: {
                    pfx: '失敗・クレーム事例（共通）',
                    d_insDats: {
                      d_flds: {
/*
                        it10c310: '',
                        it10t110: '20',
                        it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
*/
                        it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                        it10c310: '',
                        it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                      },
                    },
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        phd: '失敗・クレーム事例を入力ください',
                        b_mln: true,
                        o_sfx: 
/*
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show'])) ? 
                            _d_dats => {
                              return (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? _d_dats.d_flds.cm10c310 : null;
                            }
                          : null
*/
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return '登録:{}, ID:{}'.f(_d_dats.d_flds.cm10c310 ?? '-', _d_dats.d_flds.it10cw10 ?? '-');
                            }
                          : null
                        ,
                        stlSfx: {
                          top: null,
                          left: null,
                          bottom: - _sfxH,
                          right: ic.gn_mgnNrm,
                        },
                        ob_vsb: _d_dats => {
                          let _b = ip.$o_pmn({
                            mode: 'vsbLine', 
                            t110: _d_dats.d_flds.it10t110,
                            b21k: _d_dats.d_flds.it10b21k,
                          });
//_b = true;
                          return _b;
                        },
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                              marginBottom: _sfxH,
                            };
                          }
                          else {
                            _d = {
                              marginBottom: _sfxH,
                            };
                          };
                          return _d;
                        },
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'check'
                          : null
                        ,
                        onBtnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) global.c?.ins();
                              if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) global.c?.upd();
                            }
                          : null
                        ,
                      },
                    },
                  },
                },
              },

              {
                type: 'InpTree3',
//                b_vsb: true,
/*
                b_vsb: 
                  (
                    global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && 
                    bf.i(global.c?.state.sgc_pageMode, ['edit'])
                  ) ? 
                    false 
                  : true,
*/
                b_Vsb: true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                state: 'sdld_caseIss2',
                dd_elmDefss: {
                  it10: {
                    pfx: '失敗・クレーム事例（個人）',
                    d_insDats: 
                      (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10') ?
                        {
                          d_flds: {
    /*
                            it10c310: '',
                            it10t110: '10',
                            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
    */
                            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                            it10c310: '',
                            it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                          },
                        }
                      : null
                    ,
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        phd: '失敗・クレーム事例を入力ください',
                        b_mln: true,
/*
                        o_sfx: _d_dats => {
                          return (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? _d_dats.d_flds.cm10c310 : null;
                        },
*/
                        o_sfx:
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return '登録:{}, ID:{}'.f(_d_dats.d_flds.cm10c310 ?? '-', _d_dats.d_flds.it10cw10 ?? '-');
                            }
                          : null,
                        ob_vsb: _d_dats => {
                          let _b = ip.$o_pmn({
                            mode: 'vsbLine', 
                            t110: _d_dats.d_flds.it10t110,
                            b21k: _d_dats.d_flds.it10b21k,
                          });
//_b = true;
                          return _b;
                        },
/*
                        b_edt: 
                          (
                            global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && 
                            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])
                          ) ? 
                            false 
                          : ip.$o_pmn({
                            mode: 'edtLine', 
                            t110: _d_dats.d_flds.it10t110,
                            b21k: _d_dats.d_flds.it10b21k,
                          }),
*/
                        b_edt: 
                          (
                            global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])
                          ) ? 
                            true 
                          : false
                        ,
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                              marginBottom: _sfxH,
                            };
                          }
                          else {
                            _d = {
                              marginBottom: _sfxH,
                            };
                          };
                          return _d;
                        },
                        stlSfx: {
                          top: null,
                          left: null,
                          bottom: - _sfxH,
                          right: ic.gn_mgnNrm,
                        },
                        b_dltPrs: 
                          (
                            global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])
                          ) ? 
                            true 
                          : false
                        ,
/*
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 'clipboard',
                        onBtnPrs: _d_flds => {
                          cf.myCL_set(_d_flds.it10c310);
                        },
                        btnStlCta: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show'])) ? 
                            { 
                              top: null,
                              left: null,
                              bottom: 0,
                              right: 0,
                            }
                          : null
                        ,
*/
                        b_btnPrs: 
                          (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 'clipboard',
                        onBtnPrs: _d_flds => {
                          cf.myCL_set(_d_flds.it10c310);
                        },
                        btnStlCta: 
                          (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            { 
                              top: null,
                              left: null,
                              bottom: 0,
                              right: 0,
                            }
                          : null
                        ,
                      },
                    },
                  },
                },
              },

              {
                type:'Inp',
                b_vsb: true,
                b_edt: 
                  (
                    bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && 
                    ip.$o_pmn({ mode: 'eblPage', t110: global.c?.state.s_cm40t110 })
                  ) ? 
                    true 
                  : 
                    false
                ,
                state:'s_cm40cw10',
//                pfx:'チェックシートID　※部門運営者のみ変更可',
                pfx:'業務ID　※部門運営者のみ変更可',
                b_mln:false,
              },

              {
                type:'Inp',
                b_vsb: true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && ip.$o_pmn({ mode: 'eblPage', t110: global.c?.state.s_cm40t110 })) ? true : false,
                state:'s_cm40cx10',
                ini: '9999',
                pfx:'表示順　※部門運営者のみ変更可',
                b_mln:false,
              },
/*
              {
                type:'Pck',
                b_vsb: true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && ip.$o_pmn({ mode: 'eblPage', t110: global.c?.state.s_cm40t110 })) ? true : false,
                state:'s_cm40cz10',
                ini: '10',
                pfx:'表示区分　※部門運営者のみ変更可',
                ld_iss: [
                  {key:'10', pfx: '削除しない'},
                  {key:'0', pfx: '削除する'},
                ],
              },
*/
            ],
          }}
        />
      </this.$onChg>
    );
  }

}
